export default __webpack_public_path__ + "static/case-2-fb9db5214fb01b20fd34782268431c6d.webp";